module.exports = __webpack_public_path__ + "img/radar_on.9100b18b.svg";